export default __webpack_public_path__ + "static/media/AggregatedResults.d038d38d.png";